export default __webpack_public_path__ + "static/media/insturction-slide1.f56a8cfc.jpg";